import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'

import { firebaseApp } from 'src/services/firebase'


export const RecaptchaInput = ({ confirm, unconfirm }) => {
  const [isInitialized, setIsInitialized] = React.useState(false)

  React.useEffect(
    () => {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new firebaseApp.auth.RecaptchaVerifier(
          'recaptcha-container',
          {
            size: 'normal',
            callback: () => confirm(),
            'expired-callback': () => unconfirm(),
          }
        )
      } else {
        window.recaptchaVerifier.clear()

        window.recaptchaVerifier = new firebaseApp.auth.RecaptchaVerifier(
          'recaptcha-container',
          {
            size: 'normal',
            callback: () => confirm(),
            'expired-callback': () => unconfirm(),
          }
        )
      }

      setIsInitialized(true)

    },
    // eslint-disable-next-line
    []
  )

  React.useEffect(
    () => {
      if (isInitialized) {
        window.recaptchaVerifier.render()
      }
    },
    [isInitialized]
  )

  return (
    <>
      <div id="recaptcha-container" />
      {!isInitialized && <CircularProgress size={64} />}
    </>
  )
}

RecaptchaInput.propTypes = {
  confirm: PropTypes.func,
  unconfirm: PropTypes.func,
}
